(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  window.countChar = function (val) {
    document.getElementById('cartSpecialInstructionsCount').innerHTML = val.value.length;
  };

  // Initialize character count on page load
  document.addEventListener('DOMContentLoaded', function () {
    const textarea = document.getElementById('cartSpecialInstructions');
    if (textarea) {
      countChar(textarea);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const d = document;

    // Selectors
    const SORT_INPUT_SELECTOR = 'input[name="sort-options"]';
    const FILTER_SELECTOR = '[data-filter]';
    const CLEAR_ALL_SELECTOR = '[data-clear-filter]';
    const CLEAR_PARAM_SELECTOR = '[data-clear-param]';
    const DROPDOWN_TOGGLE_SEL = '[data-dropdown-toggle]';

    // URL/State helpers

    function buildFilterKey(scope, attr, attrScope) {
      const base = `filter.${scope}.${attr}`;
      if ((attr === 'option' || attr === 'price') && attrScope) {
        return `${base}.${attrScope.toLowerCase()}`;
      }
      return base;
    }

    function currentParams() {
      return new URLSearchParams(window.location.search);
    }

    function readStateFromParams(params) {
      const state = new Map();
      for (const [k, v] of params.entries()) {
        if (!k.startsWith('filter.')) continue;
        // Support both comma-separated and multiple same-key params
        const values = params.getAll(k);
        const set = new Set();
        values.forEach((val) => {
          String(val)
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean)
            .forEach((v) => set.add(v));
        });
        state.set(k, set);
      }
      return state;
    }

    function writeStateToParams(params, state) {
      // remove all filter.* first
      [...params.keys()].forEach((k) => {
        if (k.startsWith('filter.')) params.delete(k);
      });
      // set back - use multiple params for multiple values (Shopify standard)
      state.forEach((set, key) => {
        if (set.size) {
          set.forEach((value) => params.append(key, value));
        }
      });
    }

    function navigate(params) {
      params.delete('page'); // reset pagination
      const url = new URL(window.location.href);
      url.search = params.toString();
      window.location.href = url.toString();
    }

    // Hydrate inputs from URL (so checked state/blue styles persist)
    function hydrateFromURL() {
      const params = currentParams();
      const state = readStateFromParams(params);

      d.querySelectorAll(FILTER_SELECTOR).forEach((el) => {
        const scope = el.getAttribute('data-scope') || '';
        const attr = el.getAttribute('data-attr') || '';
        const attrScope = el.getAttribute('data-attr-scope') || '';
        const key = buildFilterKey(scope, attr, attrScope);
        const values = state.get(key);
        const type = (el.type || '').toLowerCase();

        if (!values || values.size === 0) {
          if (type === 'checkbox' || type === 'radio') el.checked = false;
          else if (el.tagName === 'SELECT' && el.multiple) [...el.options].forEach((o) => (o.selected = false));
          else if (['text', 'number', 'search'].includes(type)) el.value = '';
          else if (el.tagName === 'SELECT') el.value = '';
          return;
        }

        const v = (el.value ?? '').toString().trim();
        if (type === 'checkbox' || type === 'radio') {
          el.checked = values.has(v);
        } else if (el.tagName === 'SELECT' && el.multiple) {
          [...el.options].forEach((o) => (o.selected = values.has(o.value)));
        } else if (['text', 'number', 'search'].includes(type)) {
          if (values.size === 1) el.value = [...values][0];
        } else if (el.tagName === 'SELECT') {
          if (values.size === 1) el.value = [...values][0];
        }
      });

      // Also hydrate sort radios
      const cur = new URL(window.location.href);
      const sb = cur.searchParams.get('sort_by');
      if (sb) {
        const radio = d.getElementById(`sort-option-${sb}`);
        if (radio) radio.checked = true;
      }
    }

    // Multi-select: add or remove values from the set for this key
    function applyMultiSelect(target, state) {
      const scope = target.getAttribute('data-scope');
      const attr = target.getAttribute('data-attr');
      const attrScope = target.getAttribute('data-attr-scope');
      const key = buildFilterKey(scope, attr, attrScope);
      const val = (target.value ?? '').toString().trim();
      if (!scope || !attr) return;

      const type = (target.type || '').toLowerCase();
      const isCheckbox = type === 'checkbox';
      const isRadio = type === 'radio';
      const isSelect = target.tagName === 'SELECT';
      const isTextual = ['text', 'number', 'search'].includes(type);

      // Ensure set exists
      if (!state.has(key)) state.set(key, new Set());

      if (isCheckbox) {
        if (target.checked && val) {
          state.get(key).add(val);
        } else {
          state.get(key).delete(val);
        }
      } else if (isRadio) {
        // Radios are single-select by nature
        state.set(key, new Set());
        if (target.checked && val) state.get(key).add(val);
      } else if (isSelect) {
        if (target.multiple) {
          // Multi-select: replace with all selected options
          const selected = [...target.selectedOptions].map((o) => o.value).filter(Boolean);
          state.set(key, new Set(selected));
        } else {
          // Single select
          state.set(key, new Set());
          if (val) state.get(key).add(val);
        }
      } else if (isTextual) {
        // Text inputs replace the value
        state.set(key, new Set());
        if (val.length) state.get(key).add(val);
      } else {
        // Default: replace
        state.set(key, new Set());
        if (val) state.get(key).add(val);
      }

      // Clean up empty sets
      if (state.get(key).size === 0) state.delete(key);
    }

    // For price ranges, ensure we pull both min/max so each change keeps the pair coherent
    function syncPricePairIntoState(state) {
      const minEl = d.querySelector('[data-filter][data-attr="price"][data-attr-scope="gte"]');
      const maxEl = d.querySelector('[data-filter][data-attr="price"][data-attr-scope="lte"]');
      [minEl, maxEl].forEach((el) => {
        if (!el) return;
        const scope = el.getAttribute('data-scope');
        const attrScope = el.getAttribute('data-attr-scope');
        const key = buildFilterKey(scope, 'price', attrScope);
        const val = (el.value ?? '').toString().trim();
        if (!state.has(key)) state.set(key, new Set());
        state.set(key, new Set());
        if (val) state.get(key).add(val);
        if (state.get(key).size === 0) state.delete(key);
      });
    }

    // Sorting
    d.addEventListener('change', function (e) {
      if (!e.target.matches(SORT_INPUT_SELECTOR)) return;
      const selected = e.target.id.replace('sort-option-', '');
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', selected);
      url.searchParams.delete('page'); // reset to page 1
      window.location.href = url.toString();
    });

    // Filters (multi-select within each attribute)
    d.addEventListener('change', function (e) {
      if (!e.target.matches(FILTER_SELECTOR)) return;

      const params = currentParams();
      const state = readStateFromParams(params);

      // Update the state for this filter (add/remove from set)
      applyMultiSelect(e.target, state);

      // If this is a price field, sync the pair
      if (e.target.getAttribute('data-attr') === 'price') {
        syncPricePairIntoState(state);
      }

      writeStateToParams(params, state);
      navigate(params);
    });

    // Clear all / clear one param (optional buttons)
    d.addEventListener('click', function (e) {
      const clearAllBtn = e.target.closest(CLEAR_ALL_SELECTOR);
      if (clearAllBtn) {
        e.preventDefault();
        const params = currentParams();
        [...params.keys()].forEach((k) => {
          if (k.startsWith('filter.')) params.delete(k);
        });
        params.delete('page');
        navigate(params);
        return;
      }

      const clearParamBtn = e.target.closest(CLEAR_PARAM_SELECTOR);
      if (clearParamBtn) {
        e.preventDefault();
        const suffix = clearParamBtn.getAttribute('data-clear-param'); // e.g. "p.vendor" or "v.option.color"
        if (!suffix) return;
        const params = currentParams();
        params.delete(`filter.${suffix}`);
        params.delete('page');
        navigate(params);
      }
    });

    // Hydrate on load so selected state persists when reopening dropdowns
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hydrateFromURL, { once: true });
    } else {
      hydrateFromURL();
    }

    // If your dropdown library mounts content on open, re-hydrate after toggle
    d.addEventListener('click', (e) => {
      const btn = e.target.closest(DROPDOWN_TOGGLE_SEL);
      if (!btn) return;
      setTimeout(hydrateFromURL, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  // Clone the marquee content to create a seamless loop
  const container = document.querySelector('[data-marquee-container]');
  const content = document.querySelector('[data-marquee-content]');

  if (container && content) {
    const clone = content.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    container.appendChild(clone);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timer"] && !Shopify.designMode) return;
  try {
    
  // count-down timer
  let dest = new Date('aug 30, 2025 10:00:00').getTime();
  let x = setInterval(function () {
    let now = new Date().getTime();
    let diff = dest - now;

    // Check if the countdown has reached zero or negative
    if (diff <= 0) {
      clearInterval(x); // Stop the countdown
      return; // Exit the function
    }

    let days = Math.floor(diff / (1000 * 60 * 60 * 24));
    let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (days < 10) {
      days = `0${days}`;
    }
    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }

    // Get elements by class name
    let countdownElements = document.getElementsByClassName('countdown-element');

    // Loop through the elements and update their content
    for (let i = 0; i < countdownElements.length; i++) {
      let className = countdownElements[i].classList[1]; // Get the second class name
      switch (className) {
        case 'days':
          countdownElements[i].innerHTML = days;
          break;
        case 'hours':
          countdownElements[i].innerHTML = hours;
          break;
        case 'minutes':
          countdownElements[i].innerHTML = minutes;
          break;
        case 'seconds':
          countdownElements[i].innerHTML = seconds;
          break;
        default:
          break;
      }
    }
  }, 1000);

  } catch(e) { console.error(e); }
})();
})();
